/**
 * 求人一覧（archive-recruit）絞り込みパネルの開閉
 */
export default class RecruitFilterToggle {
  init() {
    const form = document.querySelector('[data-js-recruit-filter]');
    if (!form) {
      return;
    }

    const outer = form.querySelector('[data-js-recruit-filter-body-outer]');
    const toggle = form.querySelector('[data-js-recruit-filter-toggle]');
    if (!outer || !toggle) {
      return;
    }

    const setCollapsed = (collapsed) => {
      form.classList.toggle('is-collapsed', collapsed);
      toggle.setAttribute('aria-expanded', String(!collapsed));
      if (collapsed) {
        outer.setAttribute('inert', '');
      } else {
        outer.removeAttribute('inert');
      }
    };

    toggle.addEventListener('click', () => {
      setCollapsed(!form.classList.contains('is-collapsed'));
    });

    // select 変更で即 GET 送信（JS 無効時は <noscript> ボタン）
    const areaSelect = form.querySelector('[data-js-recruit-filter-area]');
    if (areaSelect) {
      areaSelect.addEventListener('change', () => {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }
  }
}
